

























































































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { OptionToSelectOpt } from '~/utils/types/ProductPage';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstPriceLabel, getSecondPriceLabel, getAdditionalPriceLabel } from '~/utils/helpers/product';
import { getOptionFirstlabel, getOptionSecondlabel } from '~/utils/solepro/prices';
import AddToCart from '~/components/solepro/AddToCart.vue';
import { CONFIGURABLE_TYPE_ID, DURATION_MATCHING } from '~/utils/constants/product';
import { getIsBook, isPaperOption } from '~/utils/solepro/products';
import QuantitySelector from './QuantitySelector.vue';
import PaymentFrequencySwitcher from './PaymentFrequencySwitcher.vue';
import { useConfig, useUiState } from '~/composables';
export default defineComponent({
    props: {
        option: {
            type: Object as PropType<OptionToSelectOpt>
        },
        attributeCode: {
            type: String
        },
        product: {
            type: Object as PropType<ProductForProductPageType>,
            // required: true @TODO restore
        },
        
        suggestedSku:{
            type: String
        },
        showFrequencies:{
            type: Boolean,
            deafault: true
        },
        showSuggestedSku:{
            type: Boolean,
            deafault: false
        }
    },
    components: {
        AddToCart,
        QuantitySelector,
        PaymentFrequencySwitcher
    },
    setup(props) {
        const { app: { i18n }, $fc } = useContext();
        const { product, option, attributeCode } = props;
        const isBook = getIsBook(product);
        const qty = ref(1);
        const paymentFrequencyChoosen = ref(product.entryBillingPeriod ?? product.paymentFrequencies[product.paymentFrequencies.length - 1])

        const firstPriceLabel = ref()
        const secondPriceLabel = ref()
        const addictionalLabel = ref()
        const variant = ref(null);
        const attribute_uid = ref(null)
        const tmp = {}
        tmp[product.sku]={}
        const productConfiguration = ref(tmp)

        const lowFrequency = product.paymentFrequencies[0];
        const highFrequency = product.paymentFrequencies[1];
        const hasFrequencies = lowFrequency != highFrequency && !!highFrequency;

        if (product.productTypeId == CONFIGURABLE_TYPE_ID && attributeCode) {
            variant.value = product.variants.find(el => el.product[attributeCode] == option.value_index)
        }

        const setLabels = () => {
            if (option && attributeCode) {
                firstPriceLabel.value = isBook && option.cost ? $fc(option.cost) : getOptionFirstlabel(product, { ...option, attribute_code: attributeCode }, paymentFrequencyChoosen.value, i18n, $fc)
                secondPriceLabel.value = isBook && option.cost ? 'prezzo IVA inclusa' : getOptionSecondlabel(product, { ...option, attribute_code: attributeCode }, paymentFrequencyChoosen.value, i18n, $fc)
            } else {
                /** @TODO set shipping costs */
                firstPriceLabel.value = getFirstPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)
                secondPriceLabel.value = getSecondPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)
                addictionalLabel.value = getAdditionalPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)

            }
        }

        const changeFrequency = (frequency) => {
            paymentFrequencyChoosen.value = frequency;
            /** check product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento') */
            const tipoAbbonamentoOptions = product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento')
            if (tipoAbbonamentoOptions) {
                variant.value = product.variants.find(el => DURATION_MATCHING[el.product.tipo_abbonamento] == frequency);
                if (tipoAbbonamentoOptions) {
                    attribute_uid.value = tipoAbbonamentoOptions.attribute_uid;
                    const option = tipoAbbonamentoOptions.values.find(el => DURATION_MATCHING[el.value_index] == frequency)
                    productConfiguration.value[product.sku][tipoAbbonamentoOptions.attribute_uid] = option.uid;
                }
            }
            setLabels()
        }

        

        // if is option selection the variant is automatically set, otherwise is set when the payment frequancy changes
        if (option && attributeCode) {
            const dm = DURATION_MATCHING
            variant.value = product.variants.find(el =>{
                const varValue = el.product[attributeCode].value ?? el.product[attributeCode];
                return varValue == option.value_index
                && ( !hasFrequencies || (hasFrequencies && dm[el.product.tipo_abbonamento] == paymentFrequencyChoosen.value))
            }).product;
            attribute_uid.value = product.configurable_options.find(el => el.attribute_code == attributeCode).attribute_uid
            productConfiguration.value[product.sku] =  {[attribute_uid.value]: option.uid } 
        } else changeFrequency(paymentFrequencyChoosen.value)


        const sanitizedSku=(variant.value && variant.value.sku ? variant.value.sku : product.sku).replace(/\./g,'').replaceAll(' ','-')
        const { config: storeConfig } = useConfig();
        
        return {
            email: storeConfig.value.general_contact_email,
            sku: product.sku,
            variant,
            isPaper: isPaperOption(variant),
            title: attributeCode=='tipo_consegna' ? null: option?.label,
            subtitle: attributeCode=='tipo_consegna' ? option?.label : null,
            paymentFrequencyChoosen,
            firstPriceLabel,
            secondPriceLabel,
            addictionalLabel,
            productConfiguration,
            changeFrequency,
            isBook,
            qty,
            sanitizedSku,
            scalapaySelector: '["#campaign-price-container-secondary-'+sanitizedSku+'","#campaign-price-container-'+sanitizedSku+'"]',
            hasFrequencies
        }
    },
    mounted() {
    },
    methods: {
        changeQty(val) {
            const tmp = this.qty + val;
            if (tmp < 0) {
                this.qty = 0
            } else { this.qty = tmp }
            /**@TODO manage stock qty */

        }

    }
})
